// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ce4b8a40","977":"a5d9f36d"}[chunkId] + ".chunk.js";
};